import PropTypes from 'prop-types';
import React from 'react';
import { css, cx } from 'emotion';

import theme from 'site-react/theme';

import Guides from './DesktopNavPanelGuides';
import Locations from './DesktopNavPanelLocations';

const panelStyle = css`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.neutral100};
  border-radius: ${theme.spacing.md}px;
  box-shadow: ${theme.shadow.resting};
  display: inline-block;
  font-family: ${theme.font.family.default};
  font-weight: ${theme.font.weight.light};
  letter-spacing: 0;
  left: 50%;
  position: absolute;
  text-transform: none;
  top: ${theme.spacing.xl}px;
  transform: translateX(-50%);
`;

const panelHiddenStyle = css`
  display: none;
`;

/*
 * The purpose of this component is to be a size-agnostic white box
 * with a triangular arrow on top, which happens to have some content.
 */
const DesktopNavPanel = ({ clickHandler, visible, panelName, ...props }) => (
  <div
    className={cx(panelStyle, {
      [panelHiddenStyle]: !visible,
    })}
    {...props}
  >
    {panelName === 'locations' ? (
      <Locations clickHandler={clickHandler} />
    ) : (
      <Guides clickHandler={clickHandler} />
    )}
  </div>
);

DesktopNavPanel.defaultProps = {
  clickHandler: null,
};

DesktopNavPanel.propTypes = {
  clickHandler: PropTypes.func,
  panelName: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

export { DesktopNavPanel };
export default DesktopNavPanel;
